import React from 'react';

export const safeArray = (v) => (Array.isArray(v) ? v : []);

/** Unwrap paginated list API response - handles both { data, totalCount } and raw array */
export const unwrapListResponse = (response) => {
  const body = response?.data;
  if (!body || typeof body !== 'object') return { rows: [], totalCount: 0, page: 1, pageSize: 0 };
  if (Array.isArray(body)) return { rows: body, totalCount: body.length, page: 1, pageSize: body.length };
  if (Array.isArray(body.data)) {
    return { rows: body.data, totalCount: body.totalCount ?? body.data.length, page: body.page ?? 1, pageSize: body.pageSize ?? body.data.length };
  }
  return { rows: [], totalCount: 0, page: 1, pageSize: 0 };
};

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Page error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, maxWidth: 480, margin: '40px auto', textAlign: 'center' }}>
          <h3 style={{ color: '#b91c1c', marginBottom: 12 }}>Something went wrong</h3>
          <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 16 }}>
            This page could not load. The data may be unavailable or in an unexpected format.
          </p>
          <button
            className="btn-primary"
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
